import type { SVGProps } from 'react'
const SvgOutgoingMail = (props: SVGProps<SVGSVGElement>) => (
  <svg height="1em" viewBox="0 0 18 18" width="1em" xmlns="http://www.w3.org/2000/svg" {...props}>
    <mask
      height={18}
      id="outgoing-mail_svg__a"
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
      width={18}
      x={0}
      y={0}
    >
      <path d="M0 0h18v18H0z" />
    </mask>
    <g mask="url(#outgoing-mail_svg__a)">
      <path d="m13.5 15.144-1.194-1.194 1.079-1.097h-2.988v-1.706h2.988l-1.078-1.097L13.5 8.856 16.643 12zm-10.397-2.29q-.708 0-1.207-.5a1.65 1.65 0 0 1-.5-1.207V3.853q0-.708.5-1.207a1.65 1.65 0 0 1 1.207-.5h9.544q.708 0 1.207.5.5.498.5 1.207V7.49a4.1 4.1 0 0 0-1.28-.077q-.213.016-.427.063V4.997L7.8 8.376l-4.697-3.36v6.13h5.868a3 3 0 0 0-.06.436q-.014.213-.014.418a4.3 4.3 0 0 0 .088.853zm1.303-9L7.8 6.286l3.493-2.434z" />
    </g>
  </svg>
)
export default SvgOutgoingMail
